<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        carUserTypeOptions: [],
        applyStateOptions: [],
        form: [
          { // 司机账号
            label: '司机账号',
            value: 'billId',
            type: 'input',
            placeholder: '请输入司机账号',
          },
          { // 车队名称
            label: '车队名称',
            value: 'tenantName',
            type: 'input',
            placeholder: '请输入车队名称',
          },
          { // 车队手机
            label: '车队手机',
            value: 'attachTennantLinkPhone',
            type: 'input',
            placeholder: '请输入车队手机',
          },
          { // 申请类型
            label: '申请类型',
            value: 'carUserType',
            type: 'select',
            default: -1,
            placeholder: '请选择申请类型',
          },
          { // 审核状态
            label: '审核状态',
            value: 'applyState',
            type: 'select',
            default: -1,
            placeholder: '请选择审核状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'APPLY_STATE,DRIVER_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.applyStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.carUserTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(1),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
